<template>
    <el-dialog title="查看配件称重信息" :visible.sync="visible" append-to-body v-dialogDrag width="400px"
        :close-on-click-modal="false">
        <el-form :model="form" status-icon ref="form" label-position="right" label-width="100px">
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item label="配件编号" prop="PartNumber">
                        <div class="text" :title="form.PartNumber">
                            {{ form.PartNumber }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="配件名称" prop="PartName">
                        <div class="text" :title="form.PartName">
                            {{ form.PartName }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="数量" prop="PartNum">
                        <div class="text" :title="form.PartNum">
                            {{ form.PartNum }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="重量(KG)" prop="Weight">
                        <div class="text" :title="form.Weight">
                            {{ form.Weight }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="司磅员" prop="Weigher">
                        <div class="text" :title="form.Weigher">
                            {{ form.Weigher }}
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <el-button type="canale" @click="visible = false">关 闭</el-button>
        </span>
    </el-dialog>
</template>
    
<script>
export default {
    props: ["item"],
    components: {
    },
    data() {
        return {
            visible: false,
            loading: false,
            isable: true,
            isEdit:false,
            form: {},
        };
    },
    computed: {
    },
    watch: {
        item: {
            handler: function (v) {
            if (v.KeyId) {
                this.isEdit = true;
                this.$get("WeighingPart/GetWeighingPartByID", {
                    KeyId: v.KeyId,
                }).then((r) => {
                    this.init({ ...r.Result });
                });
            } else {
                this.init({}); 
                this.isEdit = false;
            }
                this.visible = true;
            },
        },
    },
    methods: {
        init(form) {
            this.form = { ...form };
            if (this.$refs["form"]) {
                this.$refs["form"].resetFields();
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
    margin-top: 10px;
    @include font_color("text-color2");
}
</style>